<template>
  <div class="theme-wrapper">
    <iframe
      ref="iframeEl"
      class="smart-panel"
      allow="autoplay"
      border="0"
      height="100%"
      width="100%"
      :src="src"
      @load="sendSettings"
    />
  </div>
</template>

<script>
import { isEqual } from 'lodash-es';
import EventBus from '../../../../utils/event-bus';
import PanelMixins from '../../../../mixins/panel-mixins';

const { PANELS_BASE } = require('../../../../services/services');

export default {
  props: ['panel'],
  mixins: [PanelMixins],

  computed: {
    displayTime() {
      return this.panel.displayTime ? this.panel.displayTime : this.panel.settings.displayTime;
    },

    src() {
      // Pass `disable_animations` to nested iframe when necessary for screenshots and exports.
      const query = this.$route.query.disable_animations === 'true' ? 'disable_animations=true' : '';
      return `${PANELS_BASE}/render/${this.panel._id}?${query}`;
    },
  },

  mounted() {
    if (!this.isVideo) {
      EventBus.$emit('resetTimer');
      EventBus.$emit('startTimer', this.displayTime || 10000);
    }
  },

  watch: {
    panel(newVal, oldVal) {
      if (this.$refs.iframeEl && !isEqual(newVal, oldVal)) {
        this.$refs.iframeEl.contentWindow.postMessage(`tgbLive:settings:${JSON.stringify(newVal)}`, '*');
      }
    },
  },

  methods: {
    sendSettings() {
      if (this.$refs.iframeEl) {
        this.$refs.iframeEl.contentWindow.postMessage(`tgbLive:settings:${JSON.stringify(this.panel)}`, '*');
      }
    },
  },
};
</script>
